export default __webpack_public_path__ + "static/media/Sanket.14233838.jpg";